import { FrontendConfig } from '../../src/models/shard-frontend-config'
import sessionCache from "./session-cache";

/**
 * Access to own api
 */
export default class Rest {
    /**
     * Currently used to check, whether a shard exists & to get frontend config
     *
     * @param {string} shard
     * @param {string|null} tenant
     * @param {function} callback
     */
    static getShardInformation(shard, tenant, callback) {
        let headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        };

        if (typeof document.referrer !== 'undefined') {
            headers['Tenant-Rel'] = sessionCache.getTenantRel();
        }

        const request = new Request(
            '/api/shardinfo/' + shard + (tenant === null ? '' : '/' + tenant),
            {
                method: 'GET',
                headers: headers,
            }
        );

        fetch(request)
            .then((resp) => {
                if (resp.status === 200) {
                    resp.json().then(data => {
                        callback(FrontendConfig.fromJson(data), null)
                    });
                } else {
                    callback(null, {
                        statusCode: resp.status
                    })
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }
}